<!-- //
Form块的分割线
@auth xuyd
@date 2024-05-05
//-->
<template>
  <div class="card">
  </div>
</template>

<script>

export default {
  name: 'CompBlockDivider',
  data() {
    return {}
  },
  props: {
    backgroundColor: {
      type: String,
      default: '#34363d'
    },
    iconColor: {
      type: String,
      default: '#409eff'
    },
    color: {
      type: String,
      default: '#409eff'
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  width: 100%;
  height: 10px;
  margin: 10px 0 5px 0;
  border-top: 1px solid #000000;
  box-shadow: inset 0 1px 0 0 rgba(61, 61, 61, 0.6);
}

</style>
